/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-conditional */
/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-props-destruction */
/* eslint-disable react/no-unknown-property */
/* eslint-disable react/forbid-prop-types */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { ProductCarousel } from 'Component/Html/Html.component';
import { DEFAULT_STATE_NAME } from 'Component/NavigationAbstract/NavigationAbstract.config';
import CmsPageComponent from 'Route/CmsPage';
import { RECOMMENDER_HOMEPAGE_ID } from 'Route/CmsPage/CmsPage.config';
import {
    HomePageContainer as SourceHomePageContainer,
    mapDispatchToProps,
    mapStateToProps as sourceMapStateToProps
} from 'SourceRoute/HomePage/HomePage.container';
import { TotalsType } from 'Type/MiniCart.type';
import isKsa from 'Util/Arabic/isKsa';
import { isSignedIn } from 'Util/Auth';
import { handleIosStickyHeader } from 'Util/PromoBanner/PromoBanner';

import './HomePage.style';

/** @namespace Scandipwa/Route/HomePage/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state),
    totals: state.CartReducer.cartTotals,
    customer: state.MyAccountReducer.customer,
    locale: state.ConfigReducer.locale
});

/** @namespace Scandipwa/Route/HomePage/Container */
export class HomePageContainer extends SourceHomePageContainer {
    static propTypes = {
        ...super.propTypes,
        totals: TotalsType.isRequired,
        locale: PropTypes.string.isRequired,
        history: PropTypes.object.isRequired,
        customer: PropTypes.object
    };

    static defaultProps = {
        customer: {}
    };

    timeoutId = null;

    state = {
        productIds: '',
        isLoading: true,
        isTriggered: false
    };

    containerFunctions = {
        createArrayOfIds: this.createArrayOfIds.bind(this)
    };

    // eslint-disable-next-line react/sort-comp
    createArrayOfIds(ids) {
        this.setState({
            productIds: ids
        });
    }

    getCmsPageIsLoading = (isLoading) => {
        this.setState({ isLoading });
    };

    componentDidMount() {
        const { changeHeaderState } = this.props;

        changeHeaderState({
            name: DEFAULT_STATE_NAME,
            isHiddenOnMobile: true
        });

        this.requestScarabPush();

        handleIosStickyHeader();
    }

    componentWillUnmount() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    }

    requestScarabPush = () => {
        const { productIds = '', isTriggered } = this.state;
        const { customer } = this.props;

        if (!productIds && !isTriggered && window.ScarabQueue) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ isTriggered: true });
            if (isSignedIn()) {
                if (customer) {
                    window.ScarabQueue.push(['setEmail', customer.email]); // Pushing customer email if Signed in
                    this.pushRecommenderData();
                }
            } else {
                this.pushRecommenderData();
            }
        }
        // eslint-disable-next-line no-magic-numbers
        this.timeoutId = setTimeout(this.requestScarabPush, 5000); // Every 5 s requesting recommended products
        setTimeout(() => {
            clearTimeout(this.timeoutId);
            // eslint-disable-next-line no-magic-numbers
        }, 15000);
    };

    // eslint-disable-next-line react/sort-comp
    pushRecommenderData() {
        const { locale, totals: { items = [] } } = this.props;
        const { createArrayOfIds } = this.containerFunctions;

        window.ScarabQueue.push(['cart',
            items.map((product) => (
                {
                    item: product.sku,
                    price: product.prices.row_total_including_tax.value / product.quantity,
                    quantity: product.quantity
                }
            ))
        ]);
        window.ScarabQueue.push(['availabilityZone', locale]);
        window.ScarabQueue.push(['recommend', {
            logic: isKsa() ? 'HOME_LOGIC_HOMEPAGE_KSA' : 'HOME_LOGIC_HOMEPAGE', // unique logic
            limit: 10,
            containerId: RECOMMENDER_HOMEPAGE_ID, // unique container
            success(SC) {
                createArrayOfIds(SC.page.products.map((product) => product.id));
            }
        }]);
        window.ScarabQueue.push(['go']);
    }

    renderCarousel() {
        const { history } = this.props;
        const { productIds } = this.state;

        if (productIds.length === 0) {
            return null;
        }

        return (
            <ProductCarousel
              productSkuArray={ productIds }
              productButtonStyle={ null }
              title={ __('Current Must-Haves') }
              button=""
              carouselId="product_carousel_home1"
              history={ history }
              isRecommender
            />
        );
    }

    render() {
        const { isLoading } = this.state;

        return (
            <div block="HomePage" mods={ { isLoading } }>
                <CmsPageComponent
                  { ...this.props }
                  getCmsPageIsLoading={ this.getCmsPageIsLoading }
                />
                <div
                  id={ RECOMMENDER_HOMEPAGE_ID }
                >
                    { isLoading ? null : this.renderCarousel() }
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePageContainer);
